import { useMemo } from 'react';
import { IntlMessageFormat } from 'intl-messageformat';
import { useI18n } from '@xdocs/ui';
import type { TranslateVars } from '@xdocs/i18n';
import type { SettingsCatalogKey } from './settings.i18n.js';
import { SETTINGS_CATALOG } from './settings.i18n.js';

export type SettingsMessageId = `settings:${SettingsCatalogKey}`;

const PREFIX_LENGTH = 'settings:'.length;

/** `t()` for the stop-gap `settings:` scope (see `settings.i18n.ts`). */
export function useSettingsT(): { t: (id: SettingsMessageId, vars?: TranslateVars) => string } {
  const { locale } = useI18n();

  const t = useMemo(() => {
    return (id: SettingsMessageId, vars?: TranslateVars): string => {
      const key = id.slice(PREFIX_LENGTH) as SettingsCatalogKey;
      const raw = SETTINGS_CATALOG[locale][key] ?? SETTINGS_CATALOG.en[key];
      if (!vars) return raw;
      const formatted = new IntlMessageFormat(raw, locale).format(vars);
      if (formatted == null) return '';
      if (typeof formatted === 'string') return formatted;
      return Array.isArray(formatted) ? formatted.map(String).join('') : String(formatted);
    };
  }, [locale]);

  return { t };
}
